import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthHandlerInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // Update to expand the list to handle all apis that require skip-intercept header
    const skipList = ['.json'];
    let shouldSkipInterceptor = false;

    skipList.forEach(urlMatchPart => {
      if (request.url.includes(urlMatchPart)) {
        shouldSkipInterceptor = true;
      }
    });

    if (shouldSkipInterceptor) {
      request = request.clone({ setHeaders: { 'skip-intercept': 'true' }});
    }

    return next.handle(request);
  }
}
